import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { DashboardIcon, FileIcon, Payment, SettingIcon, UserFriendIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/payment-management')({
  loader: ({ context }) => {
    context.groupLabel = 'paymentManagement.sidebar.title';
    context.childRoutes = [
      {
        id: 'paymentManagement.sidebar.menu.adminPaymentSetup',
        label: 'Admin Payment Logs',
        icon: SettingIcon,
        path: '/payment-management/admin-payment-setup',
      },
      {
        id: 'paymentManagement.sidebar.menu.overview',
        label: 'Overview',
        icon: DashboardIcon,
        path: '/payment-management/overview',
      },
      {
        id: 'paymentManagement.sidebar.menu.storePaymentLogs',
        label: 'Store Payment Logs',
        icon: FileIcon,
        path: '/payment-management/store-payment-log',
      },
      {
        id: 'paymentManagement.sidebar.menu.affiliateWithdrawalLogs',
        label: 'Affiliate Withdrawal Logs',
        icon: FileIcon,
        path: '/payment-management/affiliate-log',
      },
      {
        id: 'paymentManagement.sidebar.menu.accountInformation',
        label: 'Account Information',
        icon: UserFriendIcon,
        path: '/payment-management/account-information',
      },
      {
        id: 'paymentManagement.sidebar.menu.customerPaymentLogs',
        label: 'Customer Payment Logs',
        icon: FileIcon,
        path: '/payment-management/customer-payment-logs',
      },
    ];
    return {
      crumb: <CrumbTitle id="paymentManagement.sidebar.title" icon={Payment} />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
